export const validateTemplateForm = (schema: FormSchema, data: Record<string, unknown>) => {
    const errors = {
        missingRequired: []
    }

    const recursiveCheck = (elements: FormElement[], data: Record<string, unknown>) => {
        for(const e: FormElement of elements) {
            if (e.children) recursiveCheck(e.children, data)

            const key = e.name ?? e.uuid

            if (e.props.required && !data[key]) errors.missingRequired.push(e.props.label)
        }
        return
    }

    recursiveCheck(schema.elements, data)

    return errors
}